import { IPicklistsProvider } from "../../../Core/Picklists/IPicklistsProvider";
import { PicklistQueryResponse } from "../../../Core/Picklists/PicklistTypes";
import {
    DigestFilterColumn,
    DigestLogicalOperator,
    DigestQueryFilter,
} from "../../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";

import { ICustomValidationPicklistsProvider } from "./ICustomValidationFunctionCallContext";

/***
 * Такие фильтры приходят из кастомных функций валидации
 */
interface LegacyDigestQueryFilter {
    filters: DigestFilterColumn[];
}

export class CustomValidationPicklistsProvider implements ICustomValidationPicklistsProvider {
    readonly #picklistsProvider: IPicklistsProvider;

    public constructor(picklistsProvider: IPicklistsProvider) {
        this.#picklistsProvider = picklistsProvider;
    }

    private normalizeLegacyDigestQueryFilter(
        filter: undefined | DigestQueryFilter | LegacyDigestQueryFilter
    ): undefined | DigestQueryFilter {
        if (filter == undefined) {
            return undefined;
        }
        if ("filters" in filter) {
            return {
                filter: {
                    operator: DigestLogicalOperator.Or,
                    operands: filter.filters,
                },
            };
        }
        return filter;
    }

    public async getByGId(
        gId: string,
        filter?: DigestQueryFilter | LegacyDigestQueryFilter
    ): Promise<PicklistQueryResponse> {
        return this.#picklistsProvider.getDigestApiPicklist(gId).query(this.normalizeLegacyDigestQueryFilter(filter));
    }
}
